// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_spot_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { Side } from "../../bfftypes/v1/side_pb";
import { file_bfftypes_v1_side } from "../../bfftypes/v1/side_pb";
import type { BiddingApprovalMode, BiddingApprovalStageApprovers, BiddingApprovalState, BiddingBidSendErrorCategory, BiddingBidSendStatus, BiddingCsvRowStatus, BiddingJepxReconcileOutcome, BiddingSpotBidStatus } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_spot_model.proto.
 */
export const file_bffuser_v1_bidding_spot_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_license_type, file_bfftypes_v1_side, file_bffuser_v1_bidding_common_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * スポット入札 承認依頼 (BFF mirror)。 受渡日単位で複数の BiddingSpotBid 行を束ねる。
 *
 * @generated from message bffuser.v1.BiddingSpotApprovalRequest
 */
export type BiddingSpotApprovalRequest = Message<"bffuser.v1.BiddingSpotApprovalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 受渡日。
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalMode approval_mode = 3;
   */
  approvalMode: BiddingApprovalMode;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 4;
   */
  approvalState: BiddingApprovalState;

  /**
   * 入札明細。
   *
   * @generated from field: repeated bffuser.v1.BiddingSpotBid spot_bids = 5;
   */
  spotBids: BiddingSpotBid[];

  /**
   * 送信状態 (= 提出は承認依頼単位の一括処理なので集約に持つ)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 17;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 18;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 19;
   */
  sendErrorDetail: string;

  /**
   * 承認申請者 / 申請日時 (= ステータスバー表示用)。
   *
   * @generated from field: optional string requested_by = 6;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 7;
   */
  requestedAt?: Timestamp;

  /**
   * 承認段数 (= 承認申請時に承認フロー設定から解決した段数の snapshot) と、
   * 完了した承認段数 (docs/specs/bidding/spot-bidding.md AC-BSP-094)。
   * 多段階承認の途中段階では approval_state は PENDING のまま
   * approved_stage_count だけが進み、 最終段の完了で APPROVED になる。
   * 承認申請中でない依頼と、 多段階承認の導入前に申請された依頼では
   * approval_stage_count は未設定 (= 1 段扱い)。
   *
   * @generated from field: optional int32 approval_stage_count = 20;
   */
  approvalStageCount?: number;

  /**
   * @generated from field: int32 approved_stage_count = 21;
   */
  approvedStageCount: number;

  /**
   * 承認者 / 承認日時 (= 最終承認段階の完了時にセット)。
   *
   * @generated from field: optional string approved_by = 8;
   */
  approvedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp approved_at = 9;
   */
  approvedAt?: Timestamp;

  /**
   * 差戻し日時 / 差戻し理由。
   *
   * @generated from field: optional google.protobuf.Timestamp rejected_at = 10;
   */
  rejectedAt?: Timestamp;

  /**
   * @generated from field: optional string rejected_reason = 11;
   */
  rejectedReason?: string;

  /**
   * JEPX 提出日時。
   *
   * @generated from field: optional google.protobuf.Timestamp submitted_at = 12;
   */
  submittedAt?: Timestamp;

  /**
   * 監査情報。 updated_at は楽観ロック基準値も兼ねる (
   * proto Timestamp のまま round-trip させ Date 変換しない)。
   *
   * @generated from field: optional string created_by = 13;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 15;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */
  updatedAt?: Timestamp;

  /**
   * 承認申請の時点で写した承認者のうち、 次の承認・差戻しを判定する段 (完了した段の次)
   * のエリアごとの承認者 (AC-BSP-098)。 全エリアの承認者に自分が含まれる時だけ承認者で、
   * 空なら承認者 0 人。 承認申請前・申請取消や差戻し後再編集で下書きに戻った後も空。
   *
   * @generated from field: repeated bffuser.v1.BiddingApprovalStageApprovers stage_approvers = 22;
   */
  stageApprovers: BiddingApprovalStageApprovers[];

  /**
   * @generated from field: google.protobuf.Timestamp sync_updated_at = 24;
   */
  syncUpdatedAt?: Timestamp;

  /**
   * backend の値 (internalapi.v1 の jepx_reconcile_outcome) をそのまま返す (AC-BSP-117 / AC-BSP-130)。
   *
   * @generated from field: bffuser.v1.BiddingJepxReconcileOutcome jepx_reconcile_outcome = 25;
   */
  jepxReconcileOutcome: BiddingJepxReconcileOutcome;

  /**
   * 応答時点で申請セットの「下書きに戻す」 (AC-BSP-117 / AC-BSP-129) を受け付けるか。 backend の値
   * (internalapi.v1.SpotBidApprovalRequest.returnable_to_draft) をそのまま返す。 一覧の
   * 「下書きに戻す」 は札ごとの BiddingSpotBid.returnable_to_draft で出す (入札中の札の行には出さない)。
   * この値は申請セットに送信中の札があるかを表す。
   *
   * @generated from field: bool returnable_to_draft = 26;
   */
  returnableToDraft: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingSpotApprovalRequest.
 * Use `create(BiddingSpotApprovalRequestSchema)` to create a new message.
 */
export const BiddingSpotApprovalRequestSchema: GenMessage<BiddingSpotApprovalRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 0);

/**
 * List 用 projection。
 *
 * @generated from message bffuser.v1.BiddingSpotApprovalRequestListItem
 */
export type BiddingSpotApprovalRequestListItem = Message<"bffuser.v1.BiddingSpotApprovalRequestListItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 3;
   */
  approvalState: BiddingApprovalState;

  /**
   * @generated from field: int32 bid_count = 4;
   */
  bidCount: number;

  /**
   * 承認軸の監査情報。 承認案件一覧 (approval-tasks) が申請日時降順ソート・
   * 申請者・承認者列に使う。
   *
   * @generated from field: optional string requested_by = 10;
   */
  requestedBy?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp requested_at = 11;
   */
  requestedAt?: Timestamp;

  /**
   * @generated from field: optional string approved_by = 12;
   */
  approvedBy?: string;

  /**
   * 送信状態 (= 履歴一覧で送信中 / 送信失敗バッジを出すため)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendStatus send_status = 9;
   */
  sendStatus: BiddingBidSendStatus;

  /**
   * 送信失敗の理由カテゴリ / 生 detail (= 失敗時のみ非 UNSPECIFIED / 非空)。
   *
   * @generated from field: bffuser.v1.BiddingBidSendErrorCategory send_error_category = 13;
   */
  sendErrorCategory: BiddingBidSendErrorCategory;

  /**
   * @generated from field: string send_error_detail = 14;
   */
  sendErrorDetail: string;

  /**
   * 監査情報。
   *
   * @generated from field: optional string created_by = 5;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 7;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp sync_updated_at = 16;
   */
  syncUpdatedAt?: Timestamp;

  /**
   * backend の値 (internalapi.v1 の jepx_reconcile_outcome) をそのまま返す (AC-BSP-117 / AC-BSP-130)。
   *
   * @generated from field: bffuser.v1.BiddingJepxReconcileOutcome jepx_reconcile_outcome = 17;
   */
  jepxReconcileOutcome: BiddingJepxReconcileOutcome;
};

/**
 * Describes the message bffuser.v1.BiddingSpotApprovalRequestListItem.
 * Use `create(BiddingSpotApprovalRequestListItemSchema)` to create a new message.
 */
export const BiddingSpotApprovalRequestListItemSchema: GenMessage<BiddingSpotApprovalRequestListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 1);

/**
 * スポット入札 1 行 (BFF mirror)。
 *
 * @generated from message bffuser.v1.BiddingSpotBid
 */
export type BiddingSpotBid = Message<"bffuser.v1.BiddingSpotBid"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string spot_bid_approval_request_id = 2;
   */
  spotBidApprovalRequestId: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * コマ番号 (1〜48)。
   *
   * @generated from field: int32 time_code = 4;
   */
  timeCode: number;

  /**
   * 売/買 方向。
   *
   * @generated from field: bfftypes.v1.Side direction = 5;
   */
  direction: Side;

  /**
   * 入札価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 6;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 入札量 (MWh)。
   *
   * @generated from field: google.type.Decimal volume_mwh = 7;
   */
  volumeMwh?: Decimal;

  /**
   * @generated from field: bffuser.v1.BiddingSpotBidStatus bid_status = 8;
   */
  bidStatus: BiddingSpotBidStatus;

  /**
   * 約定量 (MWh) / 約定価格 (円/kWh)。 一斉約定後に eSLJ から取得して永続化。
   * 約定待ち / 不約定では未設定。 収支 (pnl) は frontend / usecase で算出。
   *
   * @generated from field: optional google.type.Decimal matched_volume_mwh = 14;
   */
  matchedVolumeMwh?: Decimal;

  /**
   * @generated from field: optional google.type.Decimal matched_price_yen_per_kwh = 15;
   */
  matchedPriceYenPerKwh?: Decimal;

  /**
   * JEPX が発番する入札番号 (未送信は空)。
   *
   * @generated from field: optional string jepx_bid_no = 9;
   */
  jepxBidNo?: string;

  /**
   * 発注主体 (= 事業者ライセンス種別)。 OCCTO マスタの LicenseType を再利用。
   * UNSPECIFIED は、eBalance の外から出して取り込んだ札で、受渡契約コードが広域マスタに無く
   * 発注主体区分が空欄の時だけ返る (AC-BSP-111b)。 発電として扱わない。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 10;
   */
  issuerType: LicenseType;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない。 (旧 memo。 既存データは
   * 自由記述側に残すため field 番号 11 を踏襲。)
   *
   * @generated from field: optional string memo_free = 11;
   */
  memoFree?: string;

  /**
   * メモ（JEPX提出用）。 JEPX へ note として送信される記入欄。
   *
   * @generated from field: optional string memo_jepx = 16;
   */
  memoJepx?: string;

  /**
   * 監査情報 (作成者 / 作成日時)。 created_at は表示用。
   *
   * @generated from field: optional string created_by = 12;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * 価格種別 (指値 / 成行、 AC-SPOT-006)。 成行の場合 price_yen_per_kwh は 0。
   *
   * @generated from field: bffuser.v1.BiddingSpotOrderMethod order_method = 17;
   */
  orderMethod: BiddingSpotOrderMethod;

  /**
   * 受渡契約コード。 eBalance から出した札は、 発注主体区分 (issuer_type) × エリアから広域マスタを自動
   * 解決した値 (AC-BSP-001)。 ユーザーの自由入力ではない。 取り込んだ札 (AC-BSP-109) は eSLJ が返した
   * コードをそのまま持ち、 広域マスタに無いコードもありうる (AC-BSP-111b)。 この列が追加される
   * 前に作成された札は未設定 (optional のため field 自体が unset。空文字では
   * ない)。
   *
   * @generated from field: optional string delivery_contract_code = 18;
   */
  deliveryContractCode?: string;

  /**
   * ワークフロー経由で自動作成された入札の紐付け ID。 手動作成は未設定
   * (AC-BSP-001)。
   *
   * @generated from field: optional string workflow_id = 19;
   */
  workflowId?: string;

  /**
   * 応答時点で失効が確定しているか (AC-BSP-117「翌営業日向けに使い回すのは、 失効が
   * 確定してから」)。 約定軸が失効 (EXPIRED / FAILED) の札と、 承認されないまま
   * (下書き / 承認待ち / 差戻し) 入札締切を迎えた札が true。 送信失敗のまま締切を迎え、
   * JEPX が受け付けていたかを確かめていない札は false。 画面の「複製」 (AC-BSP-011) と
   * 締切超過の案内はこの値で出す。
   *
   * @generated from field: bool expiry_confirmed = 20;
   */
  expiryConfirmed: boolean;

  /**
   * 札に保存した起票由来 (AC-BSP-103)。 BULK_FIXED_VOLUME は書込時に MANUAL として
   * 保存するので返らない。 下書きの札を送り直す時は BiddingSpotBidInput.origin へ戻す。
   *
   * @generated from field: bffuser.v1.BiddingSpotBidOrigin origin = 21;
   */
  origin: BiddingSpotBidOrigin;

  /**
   * 応答時点でこの札の取下 (AC-BSP-057) を受け付けるか。 backend の値
   * (internalapi.v1.SpotBid.withdrawable) をそのまま返す。 一覧の「取下」 はこの値で出す。
   *
   * @generated from field: bool withdrawable = 22;
   */
  withdrawable: boolean;

  /**
   * 応答時点で JEPX が受け付けていたかを確かめている札か (AC-BSP-117)。 backend の値
   * (internalapi.v1.SpotBid.receipt_checking) をそのまま返す。 true の間は一覧の
   * ステータス列を入札締切の後も「送信中」 で出す。
   *
   * @generated from field: bool receipt_checking = 23;
   */
  receiptChecking: boolean;

  /**
   * @generated from field: bool needs_review = 24;
   */
  needsReview: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp needs_review_since = 25;
   */
  needsReviewSince?: Timestamp;

  /**
   * 応答時点でこの札を「下書きに戻す」 で戻すか。 backend の値
   * (internalapi.v1.SpotBid.returnable_to_draft) をそのまま返す。 一覧の行の
   * 「下書きに戻す」 はこの値で出す。
   *
   * @generated from field: bool returnable_to_draft = 26;
   */
  returnableToDraft: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingSpotBid.
 * Use `create(BiddingSpotBidSchema)` to create a new message.
 */
export const BiddingSpotBidSchema: GenMessage<BiddingSpotBid> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 2);

/**
 * 書込側の入札明細。 Create / Update Request で使う。
 *
 * @generated from message bffuser.v1.BiddingSpotBidInput
 */
export type BiddingSpotBidInput = Message<"bffuser.v1.BiddingSpotBidInput"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: int32 time_code = 2;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.Side direction = 3;
   */
  direction: Side;

  /**
   * 入札価格 (円/kWh)。 fee_auto_consider を指定しない時だけ設定する (成行は 0)。 手数料自動考慮の
   * 状態をプレビューで見ている画面は、 OFF でも fee_auto_consider (enabled=false) を送る
   * (internalapi.v1.SpotBidInput.price_yen_per_kwh と同じ)。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 4;
   */
  priceYenPerKwh?: Decimal;

  /**
   * @generated from field: google.type.Decimal volume_mwh = 5;
   */
  volumeMwh?: Decimal;

  /**
   * 発注主体 (= 事業者ライセンス種別)。 GENERATION / RETAIL / DR / SELF_WHEELING のみ有効。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 6;
   */
  issuerType: LicenseType;

  /**
   * メモ（自由記述）。 社内限定で JEPX へは送信しない。 100 文字以内 (任意)。
   *
   * @generated from field: optional string memo_free = 7;
   */
  memoFree?: string;

  /**
   * メモ（JEPX提出用）。 JEPX へ note として送信される。 100 文字以内 (任意)。
   * max_len 70 は送信先 eSLJ (day_ahead.v1 CreateBidInput.note) の 70 文字上限に合わせる。
   *
   * @generated from field: optional string memo_jepx = 8;
   */
  memoJepx?: string;

  /**
   * 価格種別 (指値 / 成行、 AC-SPOT-006)。 UNSPECIFIED (= 未送信の旧クライアント
   * 互換) は BIDDING_SPOT_ORDER_METHOD_LIMIT として扱う (BFF は backend の
   * 境界解決結果をそのまま転送するだけ)。
   *
   * @generated from field: bffuser.v1.BiddingSpotOrderMethod order_method = 9;
   */
  orderMethod: BiddingSpotOrderMethod;

  /**
   * 起票由来 (AC-BSP-103 の 上限数量(1札) 適用要否)。 UNSPECIFIED は backend が
   * MANUAL に解決する (BFF は値をそのまま転送するだけ)。
   *
   * @generated from field: bffuser.v1.BiddingSpotBidOrigin origin = 10;
   */
  origin: BiddingSpotBidOrigin;

  /**
   * 希望価格とプレビュー時の手数料自動考慮 (スポット) の状態。 指定時は backend が入札価格を決めて
   * 保存する (internalapi.v1.SpotBidInput.fee_auto_consider と同じ)。 成行とは併用できない。
   *
   * @generated from field: bffuser.v1.BiddingSpotBidFeeAutoConsiderInput fee_auto_consider = 11;
   */
  feeAutoConsider?: BiddingSpotBidFeeAutoConsiderInput;
};

/**
 * Describes the message bffuser.v1.BiddingSpotBidInput.
 * Use `create(BiddingSpotBidInputSchema)` to create a new message.
 */
export const BiddingSpotBidInputSchema: GenMessage<BiddingSpotBidInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 3);

/**
 * 組織の「手数料自動考慮 (スポット)」の状態 (BFF mirror、 backend `SpotFeeAutoConsiderState` と 1:1。
 * bid-limits.md AC-BDL-015、 spot-bidding.md AC-BSP-004b)。
 *
 * @generated from message bffuser.v1.BiddingSpotFeeAutoConsiderState
 */
export type BiddingSpotFeeAutoConsiderState = Message<"bffuser.v1.BiddingSpotFeeAutoConsiderState"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * 手数料単価 (円/kWh、 AC-IJM-007a)。 enabled かつ unavailable でない時だけ設定する。
   *
   * @generated from field: google.type.Decimal fee_yen_per_kwh = 2;
   */
  feeYenPerKwh?: Decimal;

  /**
   * ON だが手数料単価を使えない (単価が未取得・不正、 または JEPX 会員情報が未登録)。 true の間は
   * fee_auto_consider つきの作成・下書きの更新を受け付けない。
   *
   * @generated from field: bool unavailable = 3;
   */
  unavailable: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingSpotFeeAutoConsiderState.
 * Use `create(BiddingSpotFeeAutoConsiderStateSchema)` to create a new message.
 */
export const BiddingSpotFeeAutoConsiderStateSchema: GenMessage<BiddingSpotFeeAutoConsiderState> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 4);

/**
 * 手数料自動考慮で入札価格を算出したい 1 行 (一括作成は行を並べる)。
 *
 * @generated from message bffuser.v1.BiddingSpotFeeAdjustedPriceQuery
 */
export type BiddingSpotFeeAdjustedPriceQuery = Message<"bffuser.v1.BiddingSpotFeeAdjustedPriceQuery"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 2;
   */
  direction: Side;

  /**
   * 希望価格 (円/kWh)。 手数料自動考慮が OFF の組織では入札価格として扱う。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 3;
   */
  desiredPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotFeeAdjustedPriceQuery.
 * Use `create(BiddingSpotFeeAdjustedPriceQuerySchema)` to create a new message.
 */
export const BiddingSpotFeeAdjustedPriceQuerySchema: GenMessage<BiddingSpotFeeAdjustedPriceQuery> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 5);

/**
 * 保存済みの入札価格から、 手数料自動考慮 ON でその入札価格になる希望価格を逆算したい 1 行
 * (下書きの編集・再入札・複製の希望価格の初期値。 AC-BSP-004b)。
 *
 * @generated from message bffuser.v1.BiddingSpotDesiredPriceQuery
 */
export type BiddingSpotDesiredPriceQuery = Message<"bffuser.v1.BiddingSpotDesiredPriceQuery"> & {
  /**
   * @generated from field: bfftypes.v1.Side direction = 1;
   */
  direction: Side;

  /**
   * 保存済みの入札価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 2;
   */
  orderPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotDesiredPriceQuery.
 * Use `create(BiddingSpotDesiredPriceQuerySchema)` to create a new message.
 */
export const BiddingSpotDesiredPriceQuerySchema: GenMessage<BiddingSpotDesiredPriceQuery> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 6);

/**
 * BiddingSpotDesiredPriceQuery 1 行の逆算結果。
 *
 * @generated from message bffuser.v1.BiddingSpotDesiredPriceResult
 */
export type BiddingSpotDesiredPriceResult = Message<"bffuser.v1.BiddingSpotDesiredPriceResult"> & {
  /**
   * 手数料自動考慮が ON で手数料単価を使える時だけ設定する (OFF・単価を使えない時は未設定 =
   * 保存済みの入札価格がそのまま入力欄の値になる)。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 1;
   */
  desiredPriceYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotDesiredPriceResult.
 * Use `create(BiddingSpotDesiredPriceResultSchema)` to create a new message.
 */
export const BiddingSpotDesiredPriceResultSchema: GenMessage<BiddingSpotDesiredPriceResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 7);

/**
 * BiddingSpotFeeAdjustedPriceQuery 1 行の算出結果。
 *
 * @generated from message bffuser.v1.BiddingSpotFeeAdjustedPriceResult
 */
export type BiddingSpotFeeAdjustedPriceResult = Message<"bffuser.v1.BiddingSpotFeeAdjustedPriceResult"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotFeeAdjustedPriceStatus status = 1;
   */
  status: BiddingSpotFeeAdjustedPriceStatus;

  /**
   * 入札価格 (円/kWh)。 OFF は希望価格のまま、 ADJUSTED / OUT_OF_RANGE は算出値。
   * INDETERMINATE では設定しない。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 2;
   */
  orderPriceYenPerKwh?: Decimal;

  /**
   * OUT_OF_RANGE の時だけ設定する。
   *
   * @generated from field: bffuser.v1.BiddingSpotFeeAdjustedPriceViolation violation = 3;
   */
  violation?: BiddingSpotFeeAdjustedPriceViolation;
};

/**
 * Describes the message bffuser.v1.BiddingSpotFeeAdjustedPriceResult.
 * Use `create(BiddingSpotFeeAdjustedPriceResultSchema)` to create a new message.
 */
export const BiddingSpotFeeAdjustedPriceResultSchema: GenMessage<BiddingSpotFeeAdjustedPriceResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 8);

/**
 * 算出した入札価格が外れた境界 (AC-BSP-106)。 JEPX の値域と入札制限の両方を外れる時は、
 * 希望価格の入力可能範囲が狭くなる方を返す。
 *
 * @generated from message bffuser.v1.BiddingSpotFeeAdjustedPriceViolation
 */
export type BiddingSpotFeeAdjustedPriceViolation = Message<"bffuser.v1.BiddingSpotFeeAdjustedPriceViolation"> & {
  /**
   * @generated from field: bffuser.v1.BiddingSpotFeeAdjustedPriceBound bound = 1;
   */
  bound: BiddingSpotFeeAdjustedPriceBound;

  /**
   * @generated from field: bffuser.v1.BiddingSpotFeeAdjustedPriceBoundSource source = 2;
   */
  source: BiddingSpotFeeAdjustedPriceBoundSource;

  /**
   * 外れた境界そのもの (JEPX の 0.01 / 999、 または入札制限の設定値)。
   *
   * @generated from field: google.type.Decimal bound_order_price_yen_per_kwh = 3;
   */
  boundOrderPriceYenPerKwh?: Decimal;

  /**
   * 入札価格がちょうど境界になる希望価格。
   *
   * @generated from field: google.type.Decimal desired_price_bound_yen_per_kwh = 4;
   */
  desiredPriceBoundYenPerKwh?: Decimal;
};

/**
 * Describes the message bffuser.v1.BiddingSpotFeeAdjustedPriceViolation.
 * Use `create(BiddingSpotFeeAdjustedPriceViolationSchema)` to create a new message.
 */
export const BiddingSpotFeeAdjustedPriceViolationSchema: GenMessage<BiddingSpotFeeAdjustedPriceViolation> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 9);

/**
 * 作成・下書きの更新で、 画面がプレビューで見ていた手数料自動考慮 (スポット) の状態と希望価格を
 * 渡し、 入札価格の算出を backend に任せるための入力 (BFF mirror、 backend
 * `SpotBidFeeAutoConsiderInput` と 1:1。 AC-BSP-004b)。
 *
 * @generated from message bffuser.v1.BiddingSpotBidFeeAutoConsiderInput
 */
export type BiddingSpotBidFeeAutoConsiderInput = Message<"bffuser.v1.BiddingSpotBidFeeAutoConsiderInput"> & {
  /**
   * 希望価格 (円/kWh)。
   *
   * @generated from field: google.type.Decimal desired_price_yen_per_kwh = 1;
   */
  desiredPriceYenPerKwh?: Decimal;

  /**
   * プレビューで見ていた手数料単価 (BiddingSpotFeeAutoConsiderState.fee_yen_per_kwh)。
   * enabled のときだけ設定する。
   *
   * @generated from field: google.type.Decimal fee_yen_per_kwh = 2;
   */
  feeYenPerKwh?: Decimal;

  /**
   * プレビューで見ていた手数料自動考慮の ON/OFF (BiddingSpotFeeAutoConsiderState.enabled)。
   *
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;
};

/**
 * Describes the message bffuser.v1.BiddingSpotBidFeeAutoConsiderInput.
 * Use `create(BiddingSpotBidFeeAutoConsiderInputSchema)` to create a new message.
 */
export const BiddingSpotBidFeeAutoConsiderInputSchema: GenMessage<BiddingSpotBidFeeAutoConsiderInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 10);

/**
 * 通常入札 CSV の差分プレビュー 1 行 (BFF mirror、 backend `SpotBidCsvRowResult` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingSpotCsvRowResult
 */
export type BiddingSpotCsvRowResult = Message<"bffuser.v1.BiddingSpotCsvRowResult"> & {
  /**
   * CSV のデータ行番号 (ヘッダー行を除く 1 起算)。 エラー文言の「行 N」 と一致する。
   *
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.BiddingCsvRowStatus status = 2;
   */
  status: BiddingCsvRowStatus;

  /**
   * 表示用のエラー理由。 status = ERROR の時のみ非空。
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: google.type.Date target_date = 4;
   */
  targetDate?: Date;

  /**
   * @generated from field: int32 time_code = 5;
   */
  timeCode: number;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 6;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.Side direction = 7;
   */
  direction: Side;

  /**
   * 指値の `価格 (円/kWh)` 列の値 (手数料自動考慮が OFF なら入札価格、 ON なら
   * 希望価格)。 成行の行では未設定。
   *
   * @generated from field: google.type.Decimal price_yen_per_kwh = 8;
   */
  priceYenPerKwh?: Decimal;

  /**
   * 入札数量 (MW 建て)。
   *
   * @generated from field: google.type.Decimal volume_mw = 9;
   */
  volumeMw?: Decimal;

  /**
   * 行の発注主体区分 (CSV の `発注主体区分` 列)。
   *
   * @generated from field: bfftypes.v1.LicenseType issuer_type = 10;
   */
  issuerType: LicenseType;

  /**
   * JEPX に送る JEPX自由記述欄 (排出係数紐付け = 1 の行は組み立てた判別コメント)。
   *
   * @generated from field: optional string memo_jepx = 11;
   */
  memoJepx?: string;

  /**
   * 排出係数紐付け = 1 の行か (AC-SPOT-019)。
   *
   * @generated from field: bool emission_factor_linked = 12;
   */
  emissionFactorLinked: boolean;

  /**
   * 手数料自動考慮 ON で `price_yen_per_kwh` (希望価格) から算出した入札価格
   * (spot-bidding.md AC-BSP-004b)。 指値かつ ON の行だけが対象。
   *
   * @generated from field: google.type.Decimal order_price_yen_per_kwh = 13;
   */
  orderPriceYenPerKwh?: Decimal;

  /**
   * 既存の札と重複する行への警告 (AC-SPOT-022)。 重複しない行・エラー行は空。 取込は止めない。
   *
   * @generated from field: string duplicate_warning = 14;
   */
  duplicateWarning: string;
};

/**
 * Describes the message bffuser.v1.BiddingSpotCsvRowResult.
 * Use `create(BiddingSpotCsvRowResultSchema)` to create a new message.
 */
export const BiddingSpotCsvRowResultSchema: GenMessage<BiddingSpotCsvRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 11);

/**
 * 受渡日ごとの新規行数 (BFF mirror、 backend `SpotBidCsvDateCount` と 1:1)。
 *
 * @generated from message bffuser.v1.BiddingSpotCsvDateCount
 */
export type BiddingSpotCsvDateCount = Message<"bffuser.v1.BiddingSpotCsvDateCount"> & {
  /**
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.BiddingSpotCsvDateCount.
 * Use `create(BiddingSpotCsvDateCountSchema)` to create a new message.
 */
export const BiddingSpotCsvDateCountSchema: GenMessage<BiddingSpotCsvDateCount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_spot_model, 12);

/**
 * BiddingSpotOrderMethod mirrors backend internalapi.v1.SpotBidOrderMethod
 * 1:1 (wire value names match). 指値 / 成行 (spec spot-bid-normal-csv-import.md
 * AC-SPOT-006 / bid-limits.md AC-BDL-001〜004)。
 *
 * @generated from enum bffuser.v1.BiddingSpotOrderMethod
 */
export enum BiddingSpotOrderMethod {
  /**
   * @generated from enum value: BIDDING_SPOT_ORDER_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_SPOT_ORDER_METHOD_LIMIT = 1;
   */
  LIMIT = 1,

  /**
   * @generated from enum value: BIDDING_SPOT_ORDER_METHOD_MARKET = 2;
   */
  MARKET = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotOrderMethod.
 */
export const BiddingSpotOrderMethodSchema: GenEnum<BiddingSpotOrderMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 0);

/**
 * BiddingSpotBidOrigin mirrors backend internalapi.v1.SpotBidOrigin 1:1
 * (wire value names match)。 札の起票由来で、 上限数量(1札) (AC-BSP-103 /
 * bid-limits.md 1-2) を適用するかどうかを backend が解決するための signal。
 * 個別作成・編集・一括作成は同じ Create/Update RPC を共有するため、 frontend が
 * 書き込み時に申告する。
 *
 * @generated from enum bffuser.v1.BiddingSpotBidOrigin
 */
export enum BiddingSpotBidOrigin {
  /**
   * 未指定。 backend の境界で MANUAL に解決する (= ゲートを適用する fail-closed)。
   *
   * @generated from enum value: BIDDING_SPOT_BID_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 手動起票 (個別作成 / CSV 取込 / 数量を手で直した編集)。 上限数量(1札) を適用する。
   *
   * @generated from enum value: BIDDING_SPOT_BID_ORIGIN_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * 一括作成の目標カバー率モード (AC-BSP-005a)。 自動起票なので 上限数量(1札) を
   * 適用しない。
   *
   * @generated from enum value: BIDDING_SPOT_BID_ORIGIN_BULK_TARGET_COVERAGE = 2;
   */
  BULK_TARGET_COVERAGE = 2,

  /**
   * 一括作成の数量指定モード (AC-BSP-005c)。 数量は人が入力するので 上限数量(1札) を
   * 適用する。
   *
   * @generated from enum value: BIDDING_SPOT_BID_ORIGIN_BULK_FIXED_VOLUME = 3;
   */
  BULK_FIXED_VOLUME = 3,

  /**
   * 自動入札ルール (AC-BSP-060)。 適用しない。 backend の自動発注の札だけが持つ値で、
   * Create / Update で送ると InvalidArgument。
   *
   * @generated from enum value: BIDDING_SPOT_BID_ORIGIN_AUTO_RULE = 4;
   */
  AUTO_RULE = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotBidOrigin.
 */
export const BiddingSpotBidOriginSchema: GenEnum<BiddingSpotBidOrigin> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 1);

/**
 * @generated from enum bffuser.v1.BiddingSpotFeeAdjustedPriceStatus
 */
export enum BiddingSpotFeeAdjustedPriceStatus {
  /**
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 手数料自動考慮が OFF。 希望価格をそのまま入札価格とする。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_STATUS_OFF = 1;
   */
  OFF = 1,

  /**
   * ON で算出し、 JEPX の値域・入札制限の範囲内。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_STATUS_ADJUSTED = 2;
   */
  ADJUSTED = 2,

  /**
   * ON で算出したが、 JEPX の値域または入札制限を外れる (AC-BSP-106)。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_STATUS_OUT_OF_RANGE = 3;
   */
  OUT_OF_RANGE = 3,

  /**
   * ON だが手数料単価を使えず算出できない。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_STATUS_INDETERMINATE = 4;
   */
  INDETERMINATE = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotFeeAdjustedPriceStatus.
 */
export const BiddingSpotFeeAdjustedPriceStatusSchema: GenEnum<BiddingSpotFeeAdjustedPriceStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 2);

/**
 * @generated from enum bffuser.v1.BiddingSpotFeeAdjustedPriceBound
 */
export enum BiddingSpotFeeAdjustedPriceBound {
  /**
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_MIN = 1;
   */
  MIN = 1,

  /**
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_MAX = 2;
   */
  MAX = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotFeeAdjustedPriceBound.
 */
export const BiddingSpotFeeAdjustedPriceBoundSchema: GenEnum<BiddingSpotFeeAdjustedPriceBound> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 3);

/**
 * @generated from enum bffuser.v1.BiddingSpotFeeAdjustedPriceBoundSource
 */
export enum BiddingSpotFeeAdjustedPriceBoundSource {
  /**
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * JEPX 制度の値域 (0.01〜999 円/kWh)。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_SOURCE_JEPX = 1;
   */
  JEPX = 1,

  /**
   * テナント設定の入札制限の上下限価格 (bid-limits.md 1-2)。
   *
   * @generated from enum value: BIDDING_SPOT_FEE_ADJUSTED_PRICE_BOUND_SOURCE_BID_LIMIT = 2;
   */
  BID_LIMIT = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotFeeAdjustedPriceBoundSource.
 */
export const BiddingSpotFeeAdjustedPriceBoundSourceSchema: GenEnum<BiddingSpotFeeAdjustedPriceBoundSource> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 4);

/**
 * SpotBidWriteBlockedReason mirrors backend
 * internalapi.v1.SpotBidWriteBlockedReason 1:1 (wire value names match). See
 * the backend enum's godoc for the typed-vocabulary contract (not a wire
 * message field; google.rpc.ErrorInfo.reason stays a generic string)。
 * 生成された TS enum と `Record<SpotBidWriteBlockedReason, entry | undefined>`
 * により frontend は全 reason の網羅を tsc で担保する。
 *
 * 値名は backend 側と完全一致させる (frontend は
 * google.rpc.ErrorInfo.reason の文字列をこの mirror の descriptor で解決する
 * ため。 adapter/grpc/interceptor/error_reason_mirror_test.go が pin する)。
 *
 * @generated from enum bffuser.v1.SpotBidWriteBlockedReason
 */
export enum SpotBidWriteBlockedReason {
  /**
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 入札締切 (受渡日前日 10:00 JST、 AC-BSP-013) を過ぎている。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_GATE_CLOSURE = 1;
   */
  GATE_CLOSURE = 1,

  /**
   * 承認申請セットが下書きでないため札を差し替えられない (AC-BSP-066)。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_NOT_DRAFT = 2;
   */
  NOT_DRAFT = 2,

  /**
   * 現在の承認状態から要求されたライフサイクル遷移ができない。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_INVALID_STATE_TRANSITION = 3;
   */
  INVALID_STATE_TRANSITION = 3,

  /**
   * JEPX 制度上の価格 / 数量レンジ外の札が含まれる (AC-BSP-050)。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_JEPX_LIMIT_VIOLATION = 4;
   */
  JEPX_LIMIT_VIOLATION = 4,

  /**
   * 組織設定の入札制限に違反する札が含まれる (AC-BSP-008)。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_BID_LIMIT_VIOLATION = 5;
   */
  BID_LIMIT_VIOLATION = 5,

  /**
   * JEPX の階段数上限を超えている (AC-BSP-021)。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_STAIRS_EXCEEDED = 6;
   */
  STAIRS_EXCEEDED = 6,

  /**
   * 提出済み (= 二重提出)。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_ALREADY_SUBMITTED = 7;
   */
  ALREADY_SUBMITTED = 7,

  /**
   * 上限数量(コマ計) を超える (エリア × コマ × 売買) がある (AC-BSP-080 / AC-BSP-097)。
   * metadata の形は internalapi.v1 側の定義に従う。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_BID_VOLUME_TOTAL_LIMIT_VIOLATION = 8;
   */
  BID_VOLUME_TOTAL_LIMIT_VIOLATION = 8,

  /**
   * 手数料自動考慮 (スポット) の明示入力を受けたが、 組織の ON/OFF・手数料単価がプレビュー時と
   * 違う、 または ON なのに手数料単価を使えない (AC-BSP-004b)。 作成・更新で発生する。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_FEE_AUTO_CONSIDER_CHANGED = 9;
   */
  FEE_AUTO_CONSIDER_CHANGED = 9,

  /**
   * 手数料自動考慮 ON で算出した入札価格が JEPX の値域または入札制限の上下限価格を外れる
   * (AC-BSP-106)。 作成・更新で発生する。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 10;
   */
  FEE_ADJUSTED_PRICE_OUT_OF_RANGE = 10,

  /**
   * 「下書きに戻す」 の時点で送信の最中 (AC-BSP-117)。 申請セットは変わらない。 送信が終われば押し直せる。
   *
   * @generated from enum value: SPOT_BID_WRITE_BLOCKED_REASON_BID_SEND_IN_FLIGHT = 11;
   */
  BID_SEND_IN_FLIGHT = 11,
}

/**
 * Describes the enum bffuser.v1.SpotBidWriteBlockedReason.
 */
export const SpotBidWriteBlockedReasonSchema: GenEnum<SpotBidWriteBlockedReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_spot_model, 5);

